import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { AccountsGate } from "./shell/SignIn";
import { clearWebApp, startWebApp } from "./shell/UpdatePrompt";
import "@fontsource-variable/inter";
import "./theme.css";
import "./styles.css";
import "./shell/shell.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <AccountsGate>
      <App />
    </AccountsGate>
  </React.StrictMode>
);

// The web version can be installed as an app and opens without a network (Workbox:
// vite.config.ts, shell/UpdatePrompt.tsx). Not in the desktop app (its own window) nor
// the dev server (its files change all the time).
// The desktop window is http://tauri.localhost on Windows, so "http" alone does not tell
// them apart: inside it the helper cannot fetch the app's files and the window stayed
// white (2026-11-01). The shell also clears one registered before (src-tauri/src/lib.rs).
const desktopApp = "__TAURI_INTERNALS__" in window || /(^|\.)tauri\.localhost$/.test(location.hostname) || location.protocol === "tauri:";
if (desktopApp && "serviceWorker" in navigator) {
  clearWebApp();
} else if ("serviceWorker" in navigator && /^https?:$/.test(location.protocol) && !import.meta.env.DEV) {
  window.addEventListener("load", startWebApp);
}
